module.exports = __webpack_public_path__ + "img/7.14ff8d54.png";